import IncomingSimulationCard from 'components/shared/incoming-simulation-card'
import LoadingHomeSkeleton from 'components/shared/loading-home-skeleton'
import { TitleSection } from 'components/shared/title-section'
import useTranslation from 'next-translate/useTranslation'
import BoxEmptySimulations from './box-empty-sim'
import SeeAllButton from './see-all-button'

interface IncomingSimulationSectionProps {
    loading?: boolean
    incomingAndLiveSimulations?: ExamSimulation[]
    setIndexTab: (tab: number) => void
}

const IncomingSimulationSection = (props: IncomingSimulationSectionProps) => {
    const { t } = useTranslation('simulation')
    return (
        <>
            <TitleSection
                loading={props.loading}
                title={t('incomingSection.title')}
                subtitle={t('incomingSection.description')}
            />
            <div>
                {props.incomingAndLiveSimulations?.length === 0 && !props.loading ? (
                    <BoxEmptySimulations
                        title={t('emptyState.incoming.title')}
                        subtitle={t('emptyState.incoming.description')}
                    />
                ) : (
                    <div className="flex flex-col">
                        <div className="flex flex-col sm:flex-row  gap-2">
                            {props.loading ? (
                                <LoadingHomeSkeleton />
                            ) : (
                                <div className="w-full  grid grid-cols-1  md:grid-cols-2 lg:grid-cols-3 gap-3">
                                    {props.incomingAndLiveSimulations
                                        ?.map((v) => (
                                            <div key={v._id} className="w-full">
                                                <IncomingSimulationCard simulation={v} isLive={v.type === 'LIVE'} />
                                            </div>
                                        ))
                                        .slice(0, 3)}
                                </div>
                            )}
                        </div>

                        <SeeAllButton loading={props.loading} onClick={() => props.setIndexTab(2)} />
                    </div>
                )}
            </div>
        </>
    )
}

export default IncomingSimulationSection
